import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import routesConfig, { getTranslation } from "../../../Config/sidebarConfig";
import configTranslations from "../../../Config/translations.json";
import MoreMenu from "./MoreMenu";
import "./bottomNav.css";

// Primary paths always shown in the bottom bar
const PRIMARY_PATHS = ["/", "/cadeaubonnen", "/contacts", "/inbox"];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  const preferredLanguage = localStorage.getItem("preferredLanguage") || "nl";
  const t = configTranslations[preferredLanguage] || configTranslations["nl"];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  // Build primary items from config (same 4 fixed routes)
  const primaryItems = PRIMARY_PATHS.map((p) => {
    const route = routesConfig.find((r) => r.path === p);
    if (!route) return null;
    return {
      id: p,
      path: p,
      icon: route.icon,
      label: getTranslation(t, route.labelKey, p),
    };
  }).filter(Boolean);

  // Extra paths to always include in More menu regardless of isMobile flag
  const EXTRA_MORE_PATHS = [
    "/email",
    "/openinghours",
    "/mateza-cloud-apps",
    "/mededelingen",
    "/max-arrivals",
    "/max-groups",
    "/review",
    "/gallery",
    "/marketing",
    "/training",
    "/settings",
    "/stripe-dashboard",
  ];
  const EXTRA_MORE_LABEL_KEYS = { "/email": "secondary.email" };

  // Build More menu: all isMobile:true isMenu:true routes NOT in primary
  const moreItems = routesConfig
    .filter(
      (r) =>
        r.isMobile &&
        r.isMenu &&
        !r.isExternalApp &&
        !PRIMARY_PATHS.includes(r.path)
    )
    .map((r) => ({
      id: r.path,
      path: r.path,
      icon: r.icon,
      label: getTranslation(t, r.labelKey, r.path),
    }));

  const extraMoreItems = EXTRA_MORE_PATHS.map((p) => {
    const route = routesConfig.find((r) => r.path === p);
    if (!route) return null;
    const labelKey = EXTRA_MORE_LABEL_KEYS[p] || route.labelKey;
    return {
      id: p,
      path: p,
      icon: route.icon,
      label: getTranslation(t, labelKey, p),
    };
  }).filter(Boolean);

  const allMoreItems = [...moreItems, ...extraMoreItems];

  const isMoreActive = allMoreItems.some((item) => isActive(item.path));

  return (
    <>
      <nav className="bottom-nav">
        {primaryItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`bottom-nav__item ${isActive(item.path) ? "bottom-nav__item--active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              <span className="bottom-nav__icon">
                <Icon />
              </span>
              <span className="bottom-nav__label">{item.label}</span>
            </button>
          );
        })}

        {/* More button */}
        <button
          className={`bottom-nav__item ${isMoreActive ? "bottom-nav__item--active" : ""}`}
          onClick={() => setIsMoreOpen(true)}
        >
          <span className="bottom-nav__icon">
            <FaBars />
          </span>
          <span className="bottom-nav__label">More</span>
        </button>
      </nav>

      <MoreMenu
        items={allMoreItems}
        activeTab={location.pathname}
        onItemClick={(path) => {
          navigate(path);
          setIsMoreOpen(false);
        }}
        isOpen={isMoreOpen}
        onClose={() => setIsMoreOpen(false)}
      />
    </>
  );
};

export default BottomNav;
